
export const IS_DEV = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
export const HOME_URL = IS_DEV ? 'http://localhost:5000' : window.location.origin; // / = https://rakefet-games.web.app
export const URL_OF_GAME_ID = (gameId) => `${window.location.host}/g/${gameId}`